module.exports = __webpack_public_path__ + "static/media/BiPartingOut.e0dee491.svg";